import React from "react";

import DeliveryCourierProfileDashboard from "./DeliveryCourierProfileDashboard";

export default function DeliveryCourierProfile() {
  return <DeliveryCourierProfileDashboard />;
}
